import {SubAPI} from "./SubAPI";
import {Paginated} from "./Users";
import {DateString} from "./Projects";
import {VoiceClipInfo} from "./VoiceClips";

export class ProjectNotes extends SubAPI {
    upsert(input: Partial<ProjectNote>) {
        return this.fetcher.post("/api/project-note", input)
    }

    list(props: {
        project: number;
        offset?: number;
        limit?: number;
    }) {
        return this.fetcher.get<Paginated<ProjectNote>>("/api/project-notes", props)
    }

    listTags(props: {
        offset?: number;
    }) {
        return this.fetcher.get<Paginated<ProjectNoteTag>>("/api/project-note/tags", props)
    }

    upsertTag(input: Partial<ProjectNoteTag>) {
        return this.fetcher.post<ProjectNoteTag>("/api/project-note/tag", input)
    }
}

export type ProjectNote = {
    id: number;
    project: number;
    createdAt: DateString;
    updatedAt: DateString;
    updatedBy: number;
    updatedByName: string;
    content: string;

    tags: ProjectNoteTag[];
    category: string;
    parent: number | null;

    // read-only: voice clips linked to this note
    voiceClips?: VoiceClipInfo[];

    // write-only: voice_clip ids to link to this note on save
    voiceClipIds?: number[];
}

export type ProjectNoteTag = {
    id: number;
    name: string;
    bgColor: string;
    textColor: string;
    isDone: boolean;

    archived: boolean;
}